import { LOCALES, SEARCH_RESULTS_PER_PAGE } from '@constants/constants';
import useLocale from '@hooks/useLocale';
import algoliasearch from 'algoliasearch/lite';
import { startOfDay } from 'date-fns';
import singletonRouter from 'next/router';
import { PropsWithChildren } from 'react';
import { Configure, InstantSearch } from 'react-instantsearch';
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs';

const searchClient = algoliasearch(
  process.env.ALGOLIA_APP_ID!,
  process.env.ALGOLIA_SEARCH_API_KEY!,
);

interface Props {
  hitsPerPage?: number;
  withRouting?: boolean;
  showPastEvents?: boolean;
}

function SearchWrapper({
  children,
  hitsPerPage = SEARCH_RESULTS_PER_PAGE,
  withRouting,
  showPastEvents,
}: PropsWithChildren<Props>) {
  const locale = useLocale();

  const startOfToday = Math.floor(startOfDay(new Date()).getTime() / 1000);

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={process.env.ALGOLIA_INDEX_NAME!}
      routing={
        withRouting && {
          router: createInstantSearchRouterNext({
            singletonRouter,
            routerOptions: {
              createURL: ({ qsModule, routeState, location }) => {
                const { doelgroep } = singletonRouter.query;
                const queryString = qsModule.stringify({
                  ...routeState,
                  ...(doelgroep ? { doelgroep } : {}),
                });

                // Get the base URL, falling back to empty string for SSR
                const baseUrl =
                  typeof window !== 'undefined'
                    ? `${window.location.protocol}//${window.location.host}`
                    : process.env.ENVIRONMENT_URL!;

                return `${baseUrl}${location.pathname}${
                  queryString ? `?${queryString}` : ''
                }`;
              },
            },
          }),
        }
      }
    >
      <Configure
        hitsPerPage={hitsPerPage}
        filters={`(locale:"${LOCALES[locale]}") AND (NOT model:"Sub-sub categorie") ${showPastEvents ? '' : `AND (final_date>${startOfToday})`}`}
      />

      {children}
    </InstantSearch>
  );
}

export default SearchWrapper;
